import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Massnahme {
  id: number;
  beschreibung: string;
  druck_auf_bericht: number;
  foto_erforderlich: number;
  sortierung: number;
  status_id: number;
  indikator_id?: number;
  freigeben: number;
  fertig_setzen: number;
  
  // Relationships
  indikator?: Indikator;
}

export interface Indikator {
  id: number;
  code: string;
  beschreibung: string;
  farbe?: string;
  symbol_id?: string;
  anzahl_system_typen: number;
  aktive_systeme: number;
  zusatz_detail?: string;
  einheit?: string;
  schwellenwert?: number;
}

export interface MassnahmeResponse {
  data: Massnahme[];
  pagination: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class MassnahmeService {
  private apiUrl = `${environment.apiUrl}/massnahme`;

  constructor(private http: HttpClient) {}

  /**
   * Get all massnahmen with pagination and search
   */
  getMassnahmen(
    page: number = 1,
    limit: number = 10,
    search?: string,
    sortBy: string = 'sortierung',
    sortOrder: string = 'asc'
  ): Observable<MassnahmeResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder);

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<MassnahmeResponse>(this.apiUrl, { params });
  }

  /**
   * Get single massnahme by ID
   */
  getMassnahme(id: number): Observable<Massnahme> {
    return this.http.get<Massnahme>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create new massnahme
   */
  createMassnahme(massnahme: Partial<Massnahme>): Observable<Massnahme> {
    return this.http.post<Massnahme>(this.apiUrl, massnahme);
  }

  /**
   * Update existing massnahme
   */
  updateMassnahme(id: number, massnahme: Partial<Massnahme>): Observable<Massnahme> {
    return this.http.put<Massnahme>(`${this.apiUrl}/${id}`, massnahme);
  }

  /**
   * Delete massnahme
   */
  deleteMassnahme(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
